import { createContext, useContext, useEffect, useState } from 'react';

import { SettingsApi } from '~/services/settings/settingsApi';

import type { ReactElement } from 'react';
import type { LeadSource } from '~/services/settings/types';

export type SettingsContext = {
  isSettingsLoading: boolean;
  leadSources: LeadSource[];
};

export const SettingsProviderContext = createContext<SettingsContext>({
  leadSources: [],
  isSettingsLoading: true,
});

export const useSettingsContext = (): SettingsContext => useContext(SettingsProviderContext);

type Props = {
  children: ReactElement | ReactElement[];
};

export const SettingsProvider = ({ children }: Props): ReactElement => {
  const [leadSources, setLeadSources] = useState<LeadSource[]>([]);
  const [isSettingsLoading, setIsSettingsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchSettings = async (): Promise<void> => {
      const settingsResponse = await SettingsApi.getSettings();
      const leadSourcesResponse = settingsResponse?.data?.leadSources?.data || [];

      setLeadSources(leadSourcesResponse);
      setIsSettingsLoading(false);
    };

    fetchSettings();
  }, []);

  return (
    <SettingsProviderContext.Provider value={{ leadSources, isSettingsLoading }}>
      {children}
    </SettingsProviderContext.Provider>
  );
};
